window.showMoreProducts = () => {
  const selectors = {
    loadMoreButton: '.ProductList__loadMore',
    productList: '.productList__wrapper',
    loadMoreWrapper: '.ProductList__loadMoreWrapper',
    product: '.product-grid-link'
  }

  let loadMoreButton = document.querySelector(selectors.loadMoreButton);
  const productList = document.querySelector(selectors.productList);
  const loadMoreWrapper = document.querySelector(selectors.loadMoreWrapper);
  let currentPage = 1;

  // fetch section with products
  function getProducts(button) {
    let loadUrl = '?',
        sectionID = `&section_id=${button.dataset.sectionId}`,
        params = new URLSearchParams(window.location.search);

    if (params.has('page')) {
      currentPage = parseInt(params.get('page')) + 1;
      params.set('page', currentPage);
      loadUrl = loadUrl + params.toString() + sectionID;
      history.pushState(null, 'searchParam', `?${params.toString()}`);
    } else {
      currentPage = currentPage + 1;
      params.append('page', currentPage);
      loadUrl = loadUrl + params.toString() + sectionID;
      history.pushState(null, 'searchParam', `?${params.toString()}`);
    }

    fetch(loadUrl).then((response) => {
      if (response.ok) {
        return response.text();
      }
    }).then((html) => {
        let parser = new DOMParser(),
            doc = parser.parseFromString(html, 'text/html'),
            newProducts = doc.querySelector(selectors.productList),
            newButton = doc.querySelector(selectors.loadMoreButton);

        if(!newButton) {
          loadMoreWrapper.remove();
        }

        productList.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        window.dispatchEvent(new Event('collection:loadMore'));
      })
  }

  // set up observer
  const observerLoadMoreBtn = new IntersectionObserver(
    (entries) => {
      entries[0].isIntersecting ? getProducts(loadMoreButton) : null;
    },
    { threshold: [0], rootMargin: '100px' }
  );

  const startObserver = () => {
    if (loadMoreButton) {
      observerLoadMoreBtn.observe(loadMoreButton);
    }
  };

  startObserver();
}

if (document.querySelector('.ProductList__loadMore')) {
  window.showMoreProducts();
}

// variables for us code
const selectors = {
  productList: '.productList__wrapper',
  loadMoreWrapper: '.ProductList__loadMoreWrapper'
}

let productList = document.querySelector(selectors.productList);

// check if current page have 'page' in url, after reload
let params = new URLSearchParams(window.location.search);
if (params.has('page')) {
  let currentPage = params.get('page');

  for (let index = currentPage; index >= 1; index--) {
    let loadUrl = '?',
        sectionID = `&section_id=${productList.dataset.collectionSectionId}`;

    params.set('page', index);
    loadUrl = loadUrl + params.toString() + sectionID;

    fetch(loadUrl).then((response) => {
      if (response.ok) {
        return response.text();
      }
    }).then((html) => {
        let parser = new DOMParser(),
            doc = parser.parseFromString(html, 'text/html'),
            newProducts = doc.querySelector(selectors.productList),
            newButtonWrapper = doc.querySelector(selectors.loadMoreWrapper);

        if(newButtonWrapper) {
          newButtonWrapper.remove();
        }

        productList.insertAdjacentHTML('afterBegin', newProducts.innerHTML);
        scroolToSelectedProduct();
      })
  }

  function scroolToSelectedProduct() {
    if (params.has('product')) {
      let prevProductId = params.get('product'),
          prevProduct = document.querySelector(`[data-product-id="${prevProductId}"]`);

      if (prevProduct) {
        prevProduct.scrollIntoView();
      }
    }
  }
}

// push in history productID
function pushProductIdInHistory(e) {
  let params = new URLSearchParams(window.location.search);

  if (e.target.classList.contains('product-grid-link') && e.target.dataset.productId) {
    params.delete('product');
    params.append('product', e.target.dataset.productId);
    history.pushState(null, 'searchParam', `?${params.toString()}`);
  }
}

// check if we have products container before we are set listener
if (productList) {
  productList.addEventListener('click', (e) => {
    pushProductIdInHistory(e)
  });
}